import { Link } from 'react-router-dom';
import { Button } from '../../components/ui/button';
import { Card, CardContent } from '../../components/ui/card';

export function NotFoundPage() {
  return (
    <main className="flex min-h-screen items-center justify-center bg-[#060713] px-4" aria-labelledby="not-found-title">
      <Card className="max-w-lg border-white/10 bg-white/[0.03]">
        <CardContent className="space-y-6 p-10 text-center">
          <h1 id="not-found-title" className="text-4xl font-semibold text-white">Page not found</h1>
          <p className="text-sm text-gray-300">
            The page you were looking for might have been moved, retired, or is still being crafted by Lighthouse engineers.
          </p>
          <Button asChild className="bg-gold-gradient text-black hover:brightness-110">
            <Link to="/">Go home</Link>
          </Button>
        </CardContent>
      </Card>
    </main>
  );
}
